import React from 'react'

function MonthTable() {
  return (
    
    <>
    <div className='table-container'>
    <img className='table-img' src="/assets/Products/Month-data.webp" alt="month data image" />
    </div>
    </>

  )
}

export default MonthTable;